import { FilterType } from 'components/entityViewer/entitiesDropDownFilter/entityFilterControls/FilterType';
import { HARDCODED_COMPANY_SOURCES, toCompanySourceOption } from 'shared/companySource';

export const COMPANY_SOURCE_OPTIONS = HARDCODED_COMPANY_SOURCES.map(toCompanySourceOption);

export const externalSkuFilterConfig = {
    key: 'externalSku',
    label: 'External SKU',
    type: FilterType.TEXT,
    deletable: true,
    inputProps: {
        placeholder: 'Enter external SKU…',
    },
};

export const companySourceFilterConfig = {
    key: 'companySourceIds',
    label: 'Company Source',
    type: FilterType.SELECT,
    multi: true,
    options: COMPANY_SOURCE_OPTIONS,
    deletable: true,
    menuProps: {
        placeholder: 'Select company sources…',
    },
};

export const packLineFilterConfig = {
    key: 'packLineNumber',
    label: 'Pack Line',
    type: FilterType.TEXT,
    deletable: true,
    inputProps: {
        placeholder: 'Pack line number, or “unslotted”…',
    },
};

export const authUserFilterConfig = {
    key: 'authUser',
    label: 'User',
    type: FilterType.TEXT,
    deletable: true,
    inputProps: {
        placeholder: 'Enter user email…',
    },
};

export const timestampRangeFilterConfig = {
    key: 'timestampRange',
    label: 'Date',
    type: FilterType.DATE_RANGE,
    deletable: true,
};

export const OosLogFilterConfigArray = [
    externalSkuFilterConfig,
    companySourceFilterConfig,
    packLineFilterConfig,
    authUserFilterConfig,
    timestampRangeFilterConfig,
];
